type FormOpacities = 'disabled' | 'full'

export const formOpacities: Record<FormOpacities, number> = {
	full: 1,
	disabled: 0.7,
};
